module.exports = __webpack_public_path__ + "static/media/plants.0546ca5e.jpg";